var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"alert",class:("alert-" + _vm.type)},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }